import { render, staticRenderFns } from "./camDialog.vue?vue&type=template&id=210ab7f4"
import script from "./camDialog.vue?vue&type=script&lang=js"
export * from "./camDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports